import { render, staticRenderFns } from "./standing-book.vue?vue&type=template&id=0098fb6c"
import script from "./standing-book.vue?vue&type=script&lang=js"
export * from "./standing-book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports